import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

export const useTranslations = (isEditMode: boolean) => {
	const { t } = useTranslation();

	const translations = useMemo(
		() => ({
			modalTitle: isEditMode ? t('USER_TYPE.EDIT_MODAL_TITLE') : t('USER_TYPE.CREATE_MODAL_TITLE'),
			failedToSaveUserType: t('USER_TYPE.FAILED_TO_SAVE_USER_TYPE'),
			cancel: t('USER_TYPE.CANCEL'),
			formErrorsMessage: t('USER_TYPE.FORM_ERRORS_MESSAGE'),
			editButton: isEditMode ? t('USER_TYPE.SAVE') : t('USER_TYPE.SUBMIT_MODAL_BTN')
		}),
		[t, isEditMode]
	);

	return translations;
};
